import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MapPin, Building2, CheckCircle2 } from "lucide-react";
import { getFeaturedDevelopment } from "../api";

const money = (n) => (n ? `£${Number(n).toLocaleString()}` : null);

export const FeaturedDevelopment = () => {
  const [dev, setDev] = useState(null);

  useEffect(() => {
    getFeaturedDevelopment().then(setDev).catch(() => setDev(null));
  }, []);

  if (!dev) return null;
  const hero = dev.image || (dev.images || [])[0];

  return (
    <section className="py-24 bg-[#faf7f2]" data-testid="home-featured-development">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8">
        <p className="text-[12px] tracking-[0.28em] uppercase text-[#b8935f] mb-3">Featured Development</p>
        <div className="grid lg:grid-cols-2 gap-0 rounded-2xl overflow-hidden border border-[#f0ece5] bg-white shadow-sm">
          <div className="relative min-h-[300px] lg:min-h-[440px]">
            {hero && <img src={hero} alt={dev.name} className="absolute inset-0 w-full h-full object-cover" />}
            <span className="absolute top-4 left-4 text-[11px] uppercase tracking-wide bg-[#b8935f] text-white px-3 py-1.5 rounded-full">{dev.status}</span>
          </div>
          <div className="p-8 lg:p-12 flex flex-col justify-center">
            <div className="text-[13px] text-[#8a8a8a] flex items-center gap-1.5 mb-2"><Building2 size={15} /> {dev.developer}</div>
            <h2 className="font-display text-[30px] md:text-[40px] font-300 text-[#2b2b2b] leading-tight">{dev.name}</h2>
            <div className="text-[14px] text-[#6a6a6a] flex items-center gap-1.5 mt-2"><MapPin size={15} className="text-[#b8935f]" /> {dev.location}</div>
            <p className="text-[15px] text-[#4a4a4a] leading-relaxed mt-4 line-clamp-3">{dev.description}</p>
            <div className="flex flex-wrap gap-x-8 gap-y-3 mt-6">
              {money(dev.priceFrom) && <div><div className="text-[11px] uppercase text-[#8a8a8a]">Prices from</div><div className="text-[20px] font-semibold text-[#2b2b2b]">{money(dev.priceFrom)}</div></div>}
              {dev.bedsRange && <div><div className="text-[11px] uppercase text-[#8a8a8a]">Bedrooms</div><div className="text-[20px] font-semibold text-[#2b2b2b]">{dev.bedsRange}</div></div>}
              {dev.unitsAvailable != null && <div><div className="text-[11px] uppercase text-[#8a8a8a]">Available</div><div className="text-[20px] font-semibold text-[#2b2b2b]">{dev.unitsAvailable}</div></div>}
            </div>
            {(dev.amenities || []).length > 0 && (
              <div className="flex flex-wrap gap-2 mt-5">
                {dev.amenities.slice(0, 4).map((a, i) => (
                  <span key={i} className="text-[12px] text-[#4a4a4a] bg-[#faf7f2] rounded-full px-3 py-1 flex items-center gap-1"><CheckCircle2 size={13} className="text-[#b8935f]" /> {a}</span>
                ))}
              </div>
            )}
            <Link to={`/developments/${dev.id}`} data-testid="featured-dev-cta" className="mt-8 inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#2b2b2b] text-white text-[14px] font-500 hover:bg-[#b8935f] transition-colors w-fit">
              Explore this development <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedDevelopment;
